/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Radio } from '@mantine/core'

function WithEstateFilter (props: FilterableProps) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Radio
        checked={value == null}
        id="with_estate_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="withEstate"
        onChange={handleChangeEvent(onChange)}
        value=""
      />
      <Radio
        checked={value === 'true'}
        id="with_estate_filter"
        label={intl.formatMessage({
          id: 'with_estate',
          defaultMessage: 'Avec bien'
        })}
        name="withEstate"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
      <Radio
        checked={value === 'false'}
        id="without_estate_filter"
        label={intl.formatMessage({
          id: 'without_estate',
          defaultMessage: 'Sans bien'
        })}
        name="withEstate"
        onChange={handleChangeEvent(onChange)}
        value="false"
      />
    </Filter>
  )
}

export default WithEstateFilter
